import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/Tick-GIF.gif'


const _withScopeId = (n: any) => (_pushScopeId("data-v-2b558c08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "data-capture-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Strength Mapping", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Time"),
  /*#__PURE__*/_createTextVNode(": 15 minutes")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "What to do:")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " You will map yourself against the 34 Gyre Strengths, identifying which strengths are most strongly characteristic of you, and which are least strongly characteristic. ", -1))
const _hoisted_6 = {
  key: 0,
  "data-test": "job-role-data-form"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { id: "jobTitleLabel" }, " But first, please state what your current role is at your organisation? ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { id: "roleDescriptionLabel" }, "Tell us a little bit about your role (optional)", -1))
const _hoisted_9 = {
  key: 0,
  class: "character-count",
  style: {"margin-bottom":"10px"}
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "error-message",
  "data-test": "job-submit-error"
}
const _hoisted_12 = {
  key: 1,
  "data-test": "job-submit-success"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center-flex" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "success",
    class: "success-img"
  })
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Great! Scroll down to start mapping your Strengths", -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]

import { computed, onBeforeUnmount, onMounted, ref, watch, watchEffect } from "vue";
import axios, { AxiosError } from "axios";
import { useAxios } from "../../composables/api";
import { UserJobDataTageApiModel } from "../../api-models";
import { csContext } from "../../services/cs-context";
import SessionInstanceState from "../sessions/session-instance-state";

const MAX_JOB_TITLE_LENGTH = 40;
const MAX_JOB_DESCRIPTION_LENGTH = 500;

const inputHeight = 90;
const MAX_HEIGHT = 200;

export default /*#__PURE__*/_defineComponent({
  __name: 'cms-pre-strength-mapping-capture',
  emits: ["on-submit-data"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const jobTitle = ref("");
const roleDescription = ref("");

const isSubmitting = ref(false);
const hasSubmitted = ref(false);
const submitErrorMessage = ref<string | null>(null);

const textarea = ref<HTMLTextAreaElement>();

const exceededJobDescriptionLength = computed(() => {
  return roleDescription.value.length > MAX_JOB_DESCRIPTION_LENGTH;
});

const jobDescriptionCharacterCount = computed(() => {
  return roleDescription.value.length;
});

onBeforeUnmount(() => {
  SessionInstanceState.set("jobTitle", jobTitle.value);
  SessionInstanceState.set("roleDescription", roleDescription.value);
});

onMounted(() => {
  jobTitle.value = SessionInstanceState.get("jobTitle") ?? "";
  roleDescription.value = SessionInstanceState.get("roleDescription") ?? "";
});

function containsOnlyNumbersAndLetters(input: string): boolean {
  const regex = /^[a-zA-Z\d\s]+$/;
  return regex.test(input);
}

function validateJobTitle(): boolean {
  if (!jobTitle.value) {
    submitErrorMessage.value = "Please enter a job title";
    return false;
  }

  if (!containsOnlyNumbersAndLetters(jobTitle.value)) {
    submitErrorMessage.value = "Job title should not contain special characters";
    return false;
  }

  if (jobTitle.value.length > MAX_JOB_TITLE_LENGTH) {
    submitErrorMessage.value = "Job title should be no longer than 40 characters";
    return false;
  }

  if (exceededJobDescriptionLength.value) {
    submitErrorMessage.value = "Role description should be maximum 500 characters";
    return false;
  }

  return true;
}

async function onSubmitJobData(): Promise<void> {
  submitErrorMessage.value = null;
  isSubmitting.value = true;

  const isJobTitleValid = validateJobTitle();

  if (!isJobTitleValid) {
    isSubmitting.value = false;
    return;
  }

  const defaultErrorMessage =
    "There was an error submitting this information, please refresh the page and try again.";

  try {
    await axios.post<UserJobDataTageApiModel>("/api/usertagdata/job", {
      userId: csContext.user.id,
      jobTitle: jobTitle.value,
      roleDescription: roleDescription.value,
      taggedTeams: [],
    } as UserJobDataTageApiModel);
    isSubmitting.value = false;
    hasSubmitted.value = true;
    emit("on-submit-data", "preStrengthMapping");
  } catch (err) {
    const error = err as AxiosError;
    const statusCode = error.response?.status;
    isSubmitting.value = false;
    submitErrorMessage.value = statusCode?.toString().startsWith("4")
      ? error.response?.data
      : defaultErrorMessage;
    hasSubmitted.value = false;
  }
}

function clearErrorMessage(): void {
  submitErrorMessage.value = null;
}

let previousScrollHeight: number;

function updateTextAreaHeight(): void {
  const textareaElement = textarea.value as HTMLTextAreaElement;
  textareaElement.style.height = `${inputHeight}px`;

  const { scrollHeight } = textareaElement;

  if (scrollHeight > MAX_HEIGHT) {
    textareaElement.style.height = `${MAX_HEIGHT}px`;
    return;
  }

  textareaElement.style.height =
    scrollHeight > inputHeight ? `${scrollHeight}px` : `${inputHeight}px`;
}

function onInput(): void {
  if (previousScrollHeight !== textarea.value?.scrollHeight) {
    previousScrollHeight = textarea.value?.scrollHeight ?? 0;
    updateTextAreaHeight();
  }
}

function isNotEmptyString(str: string | null | undefined): boolean {
  return str !== null && str !== undefined && str.trim() !== "";
}

const { data } = useAxios<UserJobDataTageApiModel>("/api/usertagdata/getjobdata");

watchEffect(() => {
  if (!hasSubmitted.value && isNotEmptyString(data.value?.jobTitle)) {
    hasSubmitted.value = true;
    emit("on-submit-data", "preStrengthMapping");
  }
});

onMounted(() => {
  updateTextAreaHeight();
  previousScrollHeight = textarea.value?.scrollHeight ?? 0;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    (!hasSubmitted.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("form", {
            onSubmit: _withModifiers(onSubmitJobData, ["prevent"]),
            class: "data-capture-form"
          }, [
            _withDirectives(_createElementVNode("input", {
              class: "data-capture data-capture-input",
              type: "text",
              placeholder: "Job title",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((jobTitle).value = $event)),
              onFocus: clearErrorMessage,
              "data-test": "job-title-input",
              "aria-labelledby": "jobTitleLabel"
            }, null, 544), [
              [
                _vModelText,
                jobTitle.value,
                void 0,
                { trim: true }
              ]
            ]),
            _hoisted_8,
            _withDirectives(_createElementVNode("textarea", {
              class: "data-capture data-capture-textarea scrollbar",
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((roleDescription).value = $event)),
              ref_key: "textarea",
              ref: textarea,
              placeholder: "Brief description",
              onInput: onInput,
              onFocus: clearErrorMessage,
              "data-test": "role-description-input",
              "aria-labelledby": "roleDescriptionLabel"
            }, null, 544), [
              [
                _vModelText,
                roleDescription.value,
                void 0,
                { trim: true }
              ]
            ]),
            (roleDescription.value.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(jobDescriptionCharacterCount.value) + " / 500 ", 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "submit",
              disabled: isSubmitting.value,
              class: "btn btn-primary btn-lg",
              "data-test": "job-form-submit-button"
            }, " Submit ", 8, _hoisted_10)
          ], 32),
          (submitErrorMessage.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(submitErrorMessage.value), 1))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15))
  ]))
}
}

})